import type { CaptionElementProps } from 'react-day-picker/types/Props';

export const DateRangePickerCaption = ({
  date,
  classNames,
  localeUtils,
  locale,
  months,
}: CaptionElementProps) => {
  const title = months
    ? `${months[date.getMonth()]} ${date.getFullYear()}`
    : localeUtils.formatMonthTitle(date, locale);

  return (
    <div className={classNames.caption}>
      <div>{title}</div>
    </div>
  );
};
